const loadingModule = {
  namespaced: true,
  state: () => ({ 
    isButtonLoading: false, 
  }),
  mutations: {
    SET_BUTTON_LOADING(state, isLoading) {
      state.isButtonLoading = isLoading;
    },
  },
  actions: {
    setButtonLoading({ commit }, isLoading) {
      commit('SET_BUTTON_LOADING', isLoading);
    },
  },
  getters: {
    isButtonLoading: (state) => state.isButtonLoading,
  },
};

export default loadingModule;